﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Logout_1 = require("./Logout");
exports.Logout = Logout_1.default;
//# sourceMappingURL=index.js.map